import { unit } from 'mathjs';
import { fillingStatusFromValue } from 'components/utils/fillingType';
import { typeFromValue } from 'components/utils/containerType';
import { getCsvName, getUnit, resolveUnit } from './columnMappingAccessors';

export const usesFullCapacity = (row, mappings) => (
  fillingStatusFromValue(row[getCsvName(mappings, 'filling')]) === 'full'
  && typeFromValue(String(row[getCsvName(mappings, 'type')] || 'volume')) !== 'weighed-container'
);

// Only an absent usable capacity permits falling back to total capacity.
// Invalid explicit capacities must be corrected before calculating the row.
export const getFullCapacity = (row, mappings) => {
  const usable = row[getCsvName(mappings, 'usableCapacity')];
  const absent = usable === undefined || usable === null
    || (typeof usable === 'string' && usable.trim() === '');
  const key = absent ? 'totalCapacity' : 'usableCapacity';
  const csvName = getCsvName(mappings, key);
  const field = csvName || key;
  const raw = csvName ? row[csvName] : undefined;
  const value = typeof raw === 'number' || (typeof raw === 'string' && raw.trim() !== '')
    ? Number(raw) : NaN;
  if (!Number.isFinite(value) || value <= 0) return { field, value: null };
  try {
    const converted = unit(value, getUnit(mappings, key, 'L')).toNumber(
      resolveUnit(mappings, ['volumeAt20cResult', 'liquidVolumeResult'], 'L'),
    );
    return { field, value: Number.isFinite(converted) && converted > 0 ? converted : null };
  } catch (_) {
    return { field, value: null };
  }
};
